// THESE ARE USED TO ALLOW USER SEE "SPECIAL OFFER" TAB WHEN HE CHANGES IT TO DIFFERENT OFFER

import { useEffect, useState } from 'react'
import { z } from 'zod'

const Schema = z.object({
  offerId: z.string().min(1),
  planId: z.number().nonnegative(),
})

type SpecialOfferIds = z.infer<typeof Schema>

const saveSpecialOfferAndPlanId = (ids: SpecialOfferIds) => {
  if (Schema.safeParse(ids).success) {
    sessionStorage.setItem('specialOffer', JSON.stringify(ids))
  }
}

const getSpecialOfferAndPlanId = (): SpecialOfferIds | null => {
  try {
    const json = JSON.parse(sessionStorage.getItem('specialOffer') || '')
    return Schema.parse(json)
  } catch {
    return null
  }
}

const useSpecialOfferIds = () => {
  const [ids, setIds] = useState<SpecialOfferIds | null>(null)

  useEffect(() => {
    setIds(getSpecialOfferAndPlanId())
  }, [])

  return ids
}

export { saveSpecialOfferAndPlanId, getSpecialOfferAndPlanId, useSpecialOfferIds }
